import React from 'react';
import { Button, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title, Paragraph } = Typography;

interface ToolPageHeaderProps {
  backTo: string;
  backText: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  extra?: React.ReactNode;
  className?: string;
}

const ToolPageHeader: React.FC<ToolPageHeaderProps> = ({
  backTo,
  backText,
  title,
  subtitle,
  icon,
  extra,
  className,
}) => {
  const navigate = useNavigate();
  const rootClassName = ['tool-page-header', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName}>
      <Button
        type="text"
        size="small"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(backTo)}
        className="tool-page-header__back"
      >
        {backText}
      </Button>
      <div className="tool-page-header__title-row">
        <Title level={5} className="tool-page-header__title">
          {icon}
          {title}
        </Title>
        {extra}
        {subtitle ? (
          <Paragraph type="secondary" className="tool-page-header__subtitle">
            {subtitle}
          </Paragraph>
        ) : null}
      </div>
    </div>
  );
};

export default ToolPageHeader;
